import * as actionTypes from "../actionTypes/actionTypes";
import {
  getDrawingService,
  deleteDrawingService,
  saveDrawing,
} from "../services/DrawingsService";

const getDrawings = (modelId) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DRAWINGS,
    });
    getDrawingService(modelId)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.GET_DRAWINGS_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_DRAWINGS_FAILURE,
          payload: error,
        });
      });
  };
};

const setDrawingSelectedPage = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_DRAWING_PAGE,
      payload: requestPayload,
    });
  };
};

const deleteDrawing = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_DRAWING,
    });
    window.startLoading();
    deleteDrawingService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.DELETE_DRAWING_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_DRAWING_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const updateDrawing = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_DRAWING,
    });
    await saveDrawing(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.UPDATE_DRAWING_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_DRAWING_FAILURE,
          payload: error,
        });
      });
  };
};

export { getDrawings, deleteDrawing, setDrawingSelectedPage, updateDrawing };
